import { gql } from '@apollo/client'

export const StartGenerateReport = gql`
    mutation startGenerateReport($input: GenerateReportInput) {
        generateReport(input: $input) {
            instanceId
        }
    }
`
